import type { ScreenModule } from "../../../app/screen-module";
import { AuthPoolsPage } from "../pages";

export default {
	id: "tenant-admin.auth-pools",
	path: "/admin/auth-pools",
	area: "tenant-admin",
	navGroup: "利用できるもの",
	label: "共有AI接続の許可",
	roles: ["tenant_admin", "platform_admin"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: AuthPoolsPage,
} satisfies ScreenModule;
